<template>
  <v-btn :color="btnColor"
         class="normal-btn-text rounded-tag-small elevation-0"
         @click="onClickConectar">
    {{ btnText }}
  </v-btn>
</template>

<script>
import ConfiguracaoFreteService from '../configuracao-frete-service';

export default {
  props: {
    fornecedor: Object,
  },
  data() {
    return {
      statusIntegracao: null,
    };
  },
  computed: {
    isError() {
      return this.statusIntegracao === 'ERROR';
    },
    btnText() {
      if (this.isError) {
        return 'Conectar conta';
      }
      return 'Conectado';
    },
    btnColor() {
      if (this.isError) {
        return 'warning';
      }
      return 'success';
    },
  },
  methods: {
    onClickConectar() {
      if (this.isError || this.statusIntegracao) {
        this.openLoginUrl();
      }
    },
    openLoginUrl() {
      ConfiguracaoFreteService.getUrlAutenticacaoMelhorEnvio()
        .then(({ data }) => {
          window.open(data.url, '_blank');
        });
    },
    getStatus() {
      ConfiguracaoFreteService.getStatusMelhorEnvio(this.fornecedor.id)
        .then(({ data }) => {
          this.statusIntegracao = data.status;
        });
    },
  },
  created() {
    this.getStatus();
  },
};
</script>
